import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlertMessageType } from '@ux/components/alert-message/alert-message-type';

import { TravelerItemUI } from '@pax/entities/pax-ui';

@Component({
  selector: 'app-booking-lastname-alert',
  templateUrl: './booking-lastname-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BookingLastnameAlertComponent {

  @Input() public passengers: TravelerItemUI[];
  @Input() public hasAirValidation: boolean;

  public alertType: AlertMessageType = AlertMessageType.WARNING;

  constructor() { }

  private hasTwoLastName = (passenger: TravelerItemUI): boolean =>
    passenger?.defaultData?.last_name?.trim()?.split(' ').length > 1

  private hasSomeoneTwoLastNames = (): boolean =>
    this.passengers?.some(passenger => this.hasTwoLastName(passenger))

  get showLastNamesAlert(): boolean {
    return this.hasAirValidation && this.hasSomeoneTwoLastNames();
  }
}
